var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6668 1.33301H8.3335C4.4675 1.33301 1.3335 4.46702 1.3335 8.33301V31.6663C1.3335 35.5323 4.4675 38.6664 8.3335 38.6664H31.6668C35.5328 38.6664 38.6668 35.5323 38.6668 31.6663V8.33301C38.6668 4.46702 35.5328 1.33301 31.6668 1.33301Z",
    fill: "#E6F4F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 26.9997L10.6668 17.6663C11.731 16.6424 12.9381 16.1033 14.1668 16.1033C15.3956 16.1033 16.6027 16.6424 17.6668 17.6663L29.3335 29.333",
    fill: "#E6F4F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6668 24.6663L27.0002 22.333C28.0643 21.309 29.2714 20.77 30.5002 20.77C31.7289 20.77 32.936 21.309 34.0002 22.333L38.6668 26.9997",
    fill: "#E6F4F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0002 10.6663H27.0235M1.3335 26.9997L10.6668 17.6663C11.731 16.6424 12.9381 16.1033 14.1668 16.1033C15.3956 16.1033 16.6027 16.6424 17.6668 17.6663L29.3335 29.333M24.6668 24.6663L27.0002 22.333C28.0643 21.309 29.2714 20.77 30.5002 20.77C31.7289 20.77 32.936 21.309 34.0002 22.333L38.6668 26.9997M8.3335 1.33301H31.6668C35.5328 1.33301 38.6668 4.46702 38.6668 8.33301V31.6663C38.6668 35.5323 35.5328 38.6664 31.6668 38.6664H8.3335C4.4675 38.6664 1.3335 35.5323 1.3335 31.6663V8.33301C1.3335 4.46702 4.4675 1.33301 8.3335 1.33301Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/imageUpload.7302bae97d670a9a9fd4e955fe073fff.svg";
export { ForwardRef as ReactComponent };